/* ACKNOWLEDGEMENT
 * ref: https://stackoverflow.com/a/61719846
 */
import { throttle } from '@zg-rentals/zdash';
import { useEffect, useRef, useState } from 'react';

/**
 * Check if an element is in viewport

 * @param {number} offset - Number of pixels up to the observable element from the top
 * @param {number} throttleMilliseconds - Throttle observable listener, in ms
 */
export const useVisibility = ({ offset, throttleMilliseconds }: { offset: number; throttleMilliseconds: number }) => {
  const [isVisible, setIsVisible] = useState(false);
  const currentElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    checkVisibility();

    document.addEventListener('scroll', checkVisibility);
    document.addEventListener('click', checkVisibility);

    return () => {
      document.removeEventListener('scroll', checkVisibility);
      document.removeEventListener('click', checkVisibility);
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  const checkVisibility = throttle(() => {
    if (!currentElement.current) {
      setIsVisible(false);
      return;
    }

    const { top } = currentElement.current.getBoundingClientRect();

    /*
     * above = top + offset >= 0
     * below = top - offset <= window.innerHeight
     * setIsVisible(above && below);
     */
    setIsVisible(top - offset <= window.innerHeight);
  }, throttleMilliseconds);

  return { isVisible, isVisibleRef: currentElement };
};
